import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import PackageDateEditMain from 'components/PackageDateEditMain';
import PackageDateEditFlight from 'components/PackageDateEditFlight';

import { PackageDateEditTabs_packageDate$key } from '__generated__/PackageDateEditTabs_packageDate.graphql';
import { PackageDateEditTabs_data$key } from '__generated__/PackageDateEditTabs_data.graphql';

type Props = {
  packageDate: PackageDateEditTabs_packageDate$key;
  data: PackageDateEditTabs_data$key;
};

const PackageDateEditTabs: FC<Props> = props => {
  const packageDate = useFragment(
    graphql`
      fragment PackageDateEditTabs_packageDate on PackageDate {
        id

        package {
          ...PackageDateEditFlight_package
        }

        flight {
          id
        }

        ...PackageDateEditMain_packageDate
        ...PackageDateEditFlight_packageDate
      }
    `,
    props.packageDate
  );

  const data = useFragment(
    graphql`
      fragment PackageDateEditTabs_data on Query {
        ...PackageDateEditFlight_data
      }
    `,
    props.data
  );

  const tabs = [];

  tabs.push({
    title: 'Bendra informacija',
    hash: 'main',
    component: <PackageDateEditMain packageDate={packageDate} />,
  });

  if (packageDate.flight) {
    tabs.push({
      title: 'Skrydis',
      hash: 'flight',
      component: (
        <PackageDateEditFlight
          packageDate={packageDate}
          data={data}
          package={packageDate.package}
        />
      ),
    });
  }

  tabs.push({
    title: 'Apgyvendinimas',
    hash: 'accomodation',
    component: <div>Accomodation</div>,
  });

  return <Tabber tabs={tabs} />;
};

export default PackageDateEditTabs;
